// extracted by mini-css-extract-plugin
module.exports = {"cont":"userFavorites_cont__3TIEQ","section":"userFavorites_section__2EyMg","container":"userFavorites_container__UY3Ml"};